import pop from "../assets/sample_tones/POP.mp3";
import rock from "../assets/sample_tones/ROCK.mp3";
import hiphop from "../assets/sample_tones/HIP_HOP_RAP.mp3";
import classical from "../assets/sample_tones/CLASSICAL.mp3";
import jazz from "../assets/sample_tones/JAZZ.mp3";
import electronic from "../assets/sample_tones/ELECTRONIC.mp3";

export const coOrdinatorId = [
  "b6c923fa-1432-4bc7-b56a-5f93ef37c118",  // production isha
  // "7c720f1a-b79d-4244-b192-34e86f7e6fb6", // local
];

export const adminId = [
  "9d66df3a-17ae-46f6-8cef-05b62d34b3b9",  // production Vedant
  // "46cbd712-5e3b-4d19-8ad9-6b580fb0aebf", // local
];

export const songDuration = [
  "40 seconds",
  "1.0 minute",
  "1.5 minutes",
  "2.0 minutes",
  "2.5 minutes",
  "3.0 minutes",
  "3.5 minutes",
];

export const toneOptions = [
  {
    name: "Pop",
    url: pop,
  },
  {
    name: "Rock",
    url: rock,
  },
  {
    name: "Hip Hop",
    url: hiphop,
  },
  {
    name: "Classical",
    url: classical,
  },
  {
    name: "Jazz",
    url: jazz,
  },
  {
    name: "Electronic / EDM",
    url: electronic,
  },
];

export const paymentStatus = ["Partial", "Full"];

export const statesGST = [
  { gstCode: 1, state: "JAMMU AND KASHMIR" },
  { gstCode: 2, state: "HIMACHAL PRADESH" },
  { gstCode: 3, state: "PUNJAB" },
  { gstCode: 4, state: "CHANDIGARH" },
  { gstCode: 5, state: "UTTARAKHAND" },
  { gstCode: 6, state: "HARYANA" },
  { gstCode: 7, state: "DELHI" },
  { gstCode: 8, state: "RAJASTHAN" },
  { gstCode: 9, state: "UTTAR PRADESH" },
  { gstCode: 10, state: "BIHAR" },
  { gstCode: 11, state: "SIKKIM" },
  { gstCode: 12, state: "ARUNACHAL PRADESH" },
  { gstCode: 13, state: "NAGALAND" },
  { gstCode: 14, state: "MANIPUR" },
  { gstCode: 15, state: "MIZORAM" },
  { gstCode: 16, state: "TRIPURA" },
  { gstCode: 17, state: "MEGHALAYA" },
  { gstCode: 18, state: "ASSAM" },
  { gstCode: 19, state: "WEST BENGAL" },
  { gstCode: 20, state: "JHARKHAND" },
  { gstCode: 21, state: "ORISSA" },
  { gstCode: 22, state: "CHHATTISGARH" },
  { gstCode: 23, state: "MADHYA PRADESH" },
  { gstCode: 24, state: "GUJARAT" },
  { gstCode: 26, state: "DADRA AND NAGAR HAVELI & DAMAN AND DIU" },
  { gstCode: 27, state: "MAHARASHTRA" },
  { gstCode: 29, state: "KARNATAKA" },
  { gstCode: 30, state: "GOA" },
  { gstCode: 31, state: "LAKSHADWEEP" },
  { gstCode: 32, state: "KERALA" },
  { gstCode: 33, state: "TAMIL NADU" },
  { gstCode: 34, state: "PUDUCHERRY" },
  { gstCode: 35, state: "ANDAMAN AND NICOBAR" },
  { gstCode: 36, state: "TELANGANA" },
  { gstCode: 37, state: "ANDHRA PRADESH" },
  { gstCode: 38, state: "LADAKH" },
  { gstCode: 97, state: "OTHER TERRITORY" },
  { gstCode: 99, state: "OTHER COUNTRY" },
];
